<div class="top-nav">

  <button (click)="returnToSummary()" aria-label="Back" class="btn btn-back">
    <i class="fa fa-arrow-left"></i>
    <span> review management</span>
  </button>
  <div style="flex-grow: 1">

  </div>
  <div>{{heading}} | Batch deadline: {{cohort.reviewDeadline | date: 'dd/MM/yyyy'}}</div>
</div>

<app-banner [info]="true" [heading]="heading" [subHeading]="subHeading">

  <div class="toolbar-content">

    <button (click)="togglePanel('filter')" aria-label="Filter reviews" class="btn no-focus"
      [class.open]="panel==='filter'">
      <i class="fa fa-search"></i>
      <span>filter</span>
    </button>
    @if (allowChangeReviewers) {
      <button [disabled]="!data?.length || excluding" (click)="exclude()"
        aria-label="Exclude reviews" class="btn  no-focus">
        <i class="fa fa-minus"></i>
        @if (!excluding) {
          <span>exclude</span>
        }
        @if (excluding) {
          <span>excluding...</span>
        }
      </button>
    }
    @if (allowChangeReviewers) {
      <button [disabled]="!data?.length || including" (click)="include()"
        aria-label="Include reviews" class="btn  no-focus">
        <i class="fa fa-plus"></i>
        @if (!including) {
          <span>include</span>
        }
        @if (including) {
          <span>including...</span>
        }
      </button>
    }
    @if (cohort.status === CohortStatus.PendingCommit) {
      <button (click)="commit()"
        aria-label="Commit reviewer assigniments" class="btn btn-back no-focus">
        <i class="fa fa-upload"></i>
        @if (!commiting) {
          <span>commit</span>
        }
        @if (commiting) {
          <span>commiting...</span>
        }
      </button>
    }
  </div>

</app-banner>



<app-collapsible [trigger]="panel === 'filter'">
  <div class="dropdown-panel">
    <h4>
      <span>Filter</span>
      <button (click)="panel=undefined" class="btn-default btn-close"><i class="fa fa-close"></i></button>
    </h4>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group filter-param" [class.active]="filterParams.reviewer !== undefined">
          <div class="filter-header">
            <label>Reviewer</label>
            <button [class.active]="activeFilterParams.reviewer !== undefined" class="btn-clear-filter"
              (click)="clearFilter('reviewer')"><i class="fa fa-close"></i></button>
            </div>

            <mat-select class="form-control" [(ngModel)]="filterParams.reviewer" placeholder="Select a reviewer...">
              @for (reviewer of reviewers; track reviewer; let i = $index) {
                <mat-option [value]="reviewer.userId">
                {{ reviewer.name }}</mat-option>
              }
            </mat-select>

          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group filter-param" [class.active]="filterParams.reviewStage !== undefined">
            <div class="filter-header">
              <label>Stage</label>
              <button [class.active]="activeFilterParams.reviewStage !== undefined" class="btn-clear-filter"
                (click)="clearFilter('reviewStage')"><i class="fa fa-close"></i></button>
              </div>
              <mat-select name="reviewStage" class="form-control" placeholder="Select review stage..."
                [(ngModel)]="filterParams.reviewStage">
                @for (item of ReviewStage | keys; track item) {
                  <mat-option [value]="item.key">{{ item.value | caseSplit }}
                  </mat-option>
                }
              </mat-select>
            </div>

          </div>


          <div class="col-md-6">
            <div class="form-group filter-param" [class.active]="!!filterParams.registrationNumber">
              <div class="filter-header">
                <label>Registration number</label>
                <button [class.active]="activeFilterParams.registrationNumber !== undefined" class="btn-clear-filter"
                  (click)="clearFilter('registrationNumber')"><i class="fa fa-close"></i></button>
                </div>
                <input type="text" class="form-control" [(ngModel)]="filterParams.registrationNumber"
                  placeholder="Registration number..." />

                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group filter-param" [class.active]="!!filterParams.registrationStatus">
                  <div class="filter-header">
                    <label>Registration status</label>
                    <button [class.active]="activeFilterParams.registrationStatus !== undefined" class="btn-clear-filter"
                      (click)="clearFilter('registrationStatus')"><i class="fa fa-close"></i></button>
                    </div>
                    <mat-select class="form-control" [(ngModel)]="filterParams.registrationStatus"
                      placeholder="Select a status...">
                      @for (item of RegistrationStatus | keys; track item) {
                        <mat-option [value]="item.key">
                          {{ item.value }}
                        </mat-option>
                      }
                    </mat-select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group filter-param" [class.active]="filterParams.reviewSelectionStatus !== undefined">
                    <div class="filter-header">
                      <label>Selection reason</label>
                      <button [class.active]="activeFilterParams.reviewSelectionStatus !== undefined" class="btn-clear-filter"
                        (click)="clearFilter('reviewSelectionStatus')"><i class="fa fa-close"></i></button>
                      </div>
                      <mat-select class="form-control" [(ngModel)]="filterParams.reviewSelectionStatus"
                        placeholder="Why selected for review...">
                        @for (item of filterReviewSelectionStatuses; track item) {
                          <mat-option [value]="item.key">
                            {{ item.value | caseSplit }}
                          </mat-option>
                        }
                      </mat-select>

                    </div>
                    <div class="form-group filter-param" [class.active]="filterParams.maxDaysLate !== undefined">
                      <label style="display:flex"><span style="flex-grow:1">Days
                        late (upper limit)</span><span>{{filterParams.maxDaysLate}}</span></label>
                        <mat-slider [max]="70" [min]="0"><input matSliderThumb [(ngModel)]="filterParams.maxDaysLate"/>
                        </mat-slider>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group filter-param" [class.active]="filterParams.inRemediationThisYear !== undefined">
                        <div class="filter-header">
                          <label>Remediation</label>
                          <button [class.active]="activeFilterParams.inRemediationThisYear !== undefined" class="btn-clear-filter"
                            (click)="clearFilter('inRemediationThisYear')"><i class="fa fa-close"></i></button>
                          </div>
                          <div style="overflow:hidden;">
                            <mat-radio-group style="white-space: nowrap" [(ngModel)]="filterParams.inRemediationThisYear">

                              <mat-radio-button [value]="true">In remediation</mat-radio-button>
                              <mat-radio-button [value]="false">Not in remediation</mat-radio-button>
                            </mat-radio-group>
                          </div>

                        </div>
                        <div class="form-group filter-param" [class.active]="filterParams.renewalDate !== undefined">
                          <div class="filter-header">
                            <label>Renewal date</label>
                            <button [class.active]="activeFilterParams.renewalDate !== undefined" class="btn-clear-filter"
                              (click)="clearFilter('renewalDate')"><i class="fa fa-close"></i></button>
                            </div>
                            <div>
                              <app-utc-date-picker [(ngModel)]="filterParams.renewalDate"></app-utc-date-picker>
                            </div>

                          </div>
                        </div>

                      </div>


                      <div class="row">
                        <div class="col-md-12">

                          <button [disabled]="!hasFilterParams || filterParamsAreActive || loading"
                          class="btn btn-primary btn-lg btn-block" (click)="load()">Apply filter</button>
                        </div>
                      </div>



                    </div>

                  </app-collapsible>

                  <app-collapsible [trigger]="hasActiveFilterParams && !loading">
                    <div class="filter-param-info">
                      <div style="flex-grow:1">
                        @for (item of activeFilterParamsInfo; track item) {
                          <div class="filter-param-info-item">{{ item.value }} <button
                            class="btn-clear-filter" (click)="clearFilter(item.key)"><i class="fa fa-close"></i></button></div>
                          }

                        </div>
                        <button class="btn btn-default  btn-clear-all-filters" (click)="clearAllFilters()">Clear all</button>
                      </div>
                    </app-collapsible>

                    <app-pager [datasource]="service.getCohortExternalReview.bind(service)" (loaded)="onLoad($event)"></app-pager>

                    @if (cohortId) {
                      <div class="content no-boxes fadein">
                        @if (!loading) {
                          @if (data.length > 0) {
                            <div style="padding-bottom: 20px">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th style="width: 80px">Title</th>
                                    <th style="width:100px">Registrant</th>
                                    <th style="width: 140px">Stage</th>
                                    <th>Reviewers</th>
                                    <th>Indicators</th>
                                    <!---  <th>Remediation</th>-->
                                    <th>Updated</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  @for (row of data; track row) {
                                    <tr [class.editing]="editing.id === row.id" [class.excluded]="row.excludedFromReview"
                                      [class.failed]="row.failedCoreCriteria">
                                      <td class="clickable" (click)="openReview(row)">{{ row.title }}</td>
                                      <td class="clickable" (click)="openReview(row)"> @if (row.failedCoreCriteria) {
                                        <i appTooltip="Core criteria not met"
                                        class="fa fa-warning"></i>
                                      }&nbsp;{{ row.registrationNumber }}</td>
                                      <td>{{ ReviewStage[row.reviewStage] | caseSplit }}</td>
                                      <!--- <td>{{ row.dateAssigned }}</td> -->
                                      <td style="width: 360px;">
                                        <div style="display:flex; align-items: center">
                                          <div [class.hidden]="editing.id === row.id" style="flex-grow:1"><span class="primary">{{
                                            row.leadReviewerName }}</span> | <span class="secondary">{{ row.secondaryReviewerName }}</span>
                                          </div>
                                          <button (click)="toggleEdit(row)" class="btn-edit">
                                            <i class="fa fa-pencil" [class.fa-pencil]="editing.id !== row.id"
                                            [class.fa-close]="editing.id === row.id"></i>
                                          </button>
                                        </div>
                                        <app-collapsible [trigger]="editing.id === row.id">
                                          @if (editing.id === row.id) {
                                            <app-change-reviewers [editing]="editing" [row]="row" (changed)="cancelEdit()"></app-change-reviewers>
                                          }
                                        </app-collapsible>
                                      </td>
                                      <td> <span class="primary">{{ PerformanceIndicator[row.leadReviewerIndicator] | caseSplit }} </span> |
                                      <span class="secondary">{{ PerformanceIndicator[row.secondaryReviewerIndicator] | caseSplit }}</span>
                                    </td>
                                    <!---  <td> {{ row.inRemediationThisYear | friendlyBoolean }}</td>-->
                                    <td> {{ row.lastUpdated | date: 'dd/MM/yyyy' }}</td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        } @else {
                          <div class="no-data">
                            No reviews in this batch matching the given criteria.
                          </div>
                        }
                      }
                    </div>
                  } @else {
                    <div class="not-initialised">
                      <h4 style="margin-bottom:20px;">
                        This cohort hasn't been initialised yet
                      </h4>
                      <p class="intro-text">Please choose a percentage of revalidations for random sampling, and click the button below to
                      generate the initial revalidation selection.</p>
                      <div class="form-inline">
                        <div class="form-group">
                          <label>Random sample percent</label><input style="width: 80px" type="number" [(ngModel)]="randomSamplePercent"
                          class="form-control ml-4" /><span>%</span>
                        </div>
                      </div>
                      <button (click)="initializeCohort()" [disabled]="initialisingCohort" class="mt-4 btn btn-lg btn-block btn-primary">
                        @if (!initialisingCohort) {
                          <span>
                            Initialise cohort
                            {{ renewalDate | date: 'dd/MM/yyyy'}}
                          </span>
                        }
                        @if (initialisingCohort) {
                          <span>Initialising...</span>
                        }
                      </button>
                    </div>
                  }


